import { useEffect, useMemo } from "react";

import { useSelector } from "react-redux";

import { useScrollBlock } from "../../hooks/useScrollBlock.ts";

import ContactDialog from "../contact-dialog/index.jsx";
import NewsletterRegisterDialog from "../newsleter-reg-dialog/index.jsx";
import NewsletterUnregisterDialog from "../newsletter-unreg-dialog/index.jsx";
import LegalDialog from "../legal-dialog/index.jsx";
import PrivacyDialog from "../privacy-dialog/index.jsx";

function DialogContainer() {
  const { ui } = useSelector((state) => state);

  const [blockScroll, allowScroll] = useScrollBlock();

  const isOpenDialog = useMemo(() => {
    return [
      ui.show_newsletter_register_dialog,
      ui.show_newsletter_unregister_dialog,
      ui.show_contact_dialog,
      ui.show_legal_dialog,
      ui.show_privacy_dialog,
    ].some((i) => i);
  }, [
    ui.show_newsletter_register_dialog,
    ui.show_newsletter_unregister_dialog,
    ui.show_contact_dialog,
    ui.show_legal_dialog,
    ui.show_privacy_dialog,
  ]);

  useEffect(() => {
    isOpenDialog ? blockScroll() : allowScroll();
  }, [isOpenDialog, allowScroll, blockScroll]);

  return (
    <>
      {ui.show_newsletter_register_dialog && <NewsletterRegisterDialog />}
      {ui.show_newsletter_unregister_dialog && <NewsletterUnregisterDialog />}
      {ui.show_contact_dialog && <ContactDialog />}
      {ui.show_legal_dialog && <LegalDialog />}
      {ui.show_privacy_dialog && <PrivacyDialog />}
    </>
  );
}

export default DialogContainer;
